import { apiFetch } from '@ami/react/core';

export function calculateTravelExpense(priceZoneId, dealerGroupId, from, to) {
  const payload = {
    priceZoneId,
    dealerGroupId,
    from,
    to,
  };
  return apiFetch('installation/travel/expense', 'POST', payload);
}
